import { useCallback, useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import { api, fancallWhen } from "@/lib/api";
import { EmptyState } from "@/components/Bits";
import RaffleDetail from "@/components/admin/RaffleDetail";

export default function RafflesAdmin({ refreshKey = 0, onChanged }) {
  const [raffles, setRaffles] = useState(null);
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => {
    api.get("/raffles").then((r) => {
      setRaffles(r.data);
      setSelected((s) => (s && r.data.some((x) => x.id === s) ? s : r.data[0]?.id || null));
    }).catch(() => setRaffles([]));
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  if (raffles === null) return <div className="text-zinc-500 text-sm">Loading…</div>;
  if (!raffles.length) return <EmptyState testId="raffles-empty-state" title="No fancall rounds yet" hint="Drops set to the Fancall Round fill rule show up here automatically." />;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[300px_minmax(0,1fr)] gap-5 items-start">
      <div className="space-y-2 min-w-0" data-testid="raffles-list">
        {raffles.map((r) => (
          <button
            key={r.id}
            data-testid={`raffle-item-${r.id}`}
            onClick={() => setSelected(r.id)}
            className={`w-full text-left rounded-xl border px-4 py-3 transition-colors duration-200 ${selected === r.id ? "border-amber-500/50 bg-amber-500/5" : "border-white/5 bg-zinc-900/60 hover:border-white/20"}`}
          >
            <div className="flex items-center gap-2">
              <Ticket className="h-4 w-4 text-amber-300 shrink-0" />
              <span className="font-semibold truncate">{r.name}</span>
            </div>
            <div className="text-xs text-zinc-500 mt-1 truncate">{fancallWhen(r) || "Date TBA"}</div>
            <div className="text-xs mt-1.5 font-mono text-zinc-400">
              {r.total_entries} entries · {r.winners.length ? `Won: ${r.winners.join(", ")}` : "No winner yet"}
            </div>
          </button>
        ))}
      </div>
      {selected && <RaffleDetail key={`${selected}-${refreshKey}`} raffleId={selected} onChanged={onChanged || load} />}
    </div>
  );
}
